import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const KIND = {
    warn: { ic: Icon.warn, cls: 'red' },
    check: { ic: Icon.check, cls: '' },
    comment: { ic: Icon.comment, cls: 'indigo' },
    flag: { ic: Icon.flag, cls: 'yellow' },
};

const relTime = (iso) => {
    if (!iso) return '';
    const diff = Date.now() - new Date(iso).getTime();
    const m = Math.round(diff / 60000);
    if (m < 60) return `${m}m ago`;
    const h = Math.round(m / 60);
    if (h < 24) return `${h}h ago`;
    const d = Math.round(h / 24);
    return `${d}d ago`;
};

const AttentionCard = ({ items = [] }) => (
    <div className="rs-card col-4">
        <div className="rs-card-h">
            <h3>Needs your attention</h3>
            <span className="count">{items.length}</span>
            <div className="spacer" />
            <Link className="link" to="/dashboard/messages">
                View queue {Icon.arrow}
            </Link>
        </div>
        <div className="aq">
            {items.length === 0 && (
                <div className="aq-item" style={{ color: 'var(--muted)' }}>
                    <span className="aq-ic"><span>{Icon.check}</span></span>
                    <div className="aq-body">
                        <div className="t1">All caught up</div>
                        <div className="t2">Nothing needs your attention right now.</div>
                    </div>
                </div>
            )}
            {items.slice(0, 4).map((it) => {
                const k = KIND[it.kind] || KIND.check;
                return (
                    <div className="aq-item" key={it.id}>
                        <span className={`aq-ic ${k.cls}`}>{k.ic}</span>
                        <div className="aq-body">
                            <div className="t1">
                                {it.title}
                                {it.lang && <span className="lang-tag">{it.lang}</span>}
                            </div>
                            <div className="t2" dangerouslySetInnerHTML={{ __html: it.body || '' }} />
                            <div className="t3">
                                <span>{relTime(it.createdAt)}</span>
                                <span>·</span>
                                <span>{it.actor || 'System'}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
);

export default AttentionCard;
